import { render, staticRenderFns } from "./Dining.vue?vue&type=template&id=0d98ad3a&scoped=true&"
import script from "./Dining.vue?vue&type=script&lang=js&"
export * from "./Dining.vue?vue&type=script&lang=js&"
import style0 from "./Dining.vue?vue&type=style&index=0&id=0d98ad3a&scoped=true&lang=css&"
import style1 from "./Dining.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d98ad3a",
  null
  
)

export default component.exports